import closeIcon from "../../assets/imgs/close-modal-icon.svg";
import errorIcon from "../../assets/imgs/modal-error.png";
import { t } from "../../services/formatters";
import { Button } from "../Button";
import "./style.css";

export const ErrorModal = ({ open = false, onCloseModal = () => {}, title = "", text = "" }) => {
  return (
    <div className={`modal-component modal-container ${open ? "open" : ""}`}>
      <div onClick={onCloseModal} className="modal-backdrop"></div>

      <div className="modal-content">
        <div onClick={onCloseModal} className="close-modal-icon modal-element text-right">
          <img className="clickable" src={closeIcon} />
        </div>

        <div className={`section white-box input-box-component`}>
          <h2>{t("errore")}</h2>
          <div className="text-center">
            <img className="logo" src={errorIcon} alt={t("errore")} />

            <br />
            <br />

            <p dangerouslySetInnerHTML={{ __html: text }}></p>
            <br />

            <Button text={t("chiudi")} className="btn-responsive always-style" onClick={onCloseModal} />
          </div>
        </div>
      </div>
    </div>
  );
};
